import { useCallback } from 'modules/core/hooks/useCallback'

import { CustomizableTableProps } from 'modules/finance/components/FinancialWorkspace/components/Table/types'
import { useCurrentPage } from 'modules/finance/components/FinancialWorkspace/hooks/useCurrentPage'
import { InsightTableGroupBy } from 'modules/finance/components/FinancialWorkspace/types/table'

interface Props {
  group?: InsightTableGroupBy
  setGroup: (value?: InsightTableGroupBy) => void
  tableProps: CustomizableTableProps
}

export const GroupBy = ({ group, setGroup, tableProps }: Props) => {
  const { groupByComponent } = tableProps
  const currentRoute = useCurrentPage()

  const handleGroupChanged = useCallback(
    (value?: InsightTableGroupBy) => {
      setGroup(value)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentRoute]
  )

  if (!groupByComponent) return null

  return groupByComponent({ group, onChange: handleGroupChanged })
}
